// Availability-kind colors — the ONE definition, shared by
// MonthCalendar's cells, CalendarSection's legend, and
// BookingCalendar's tinted day cells, so swatches and cells can never
// drift. Deliberately saturated: mobile = clear sage GREEN, in-studio =
// clear slate BLUE, both/flexible = warm GOLD.
//
// Lives in shared/ (dependency-free) so pure-logic test suites can
// import calendar helpers without dragging AuthContext/window along.
// Flexible/both gets its OWN hue (the drift-token family) instead of a
// green/blue diagonal — at pill size the split read as a muddy third
// grey (Ivan, 2026-08-27). Three flat, maximally distinct hues in the
// same muted register. bothBorder/bothInk are the companion tones for
// surfaces that render flexible blocks/pills (DaySchedule timeline
// card, AvailabilityList pill) — the day tile, the timeline block and
// the list pill must never disagree about what "flexible" looks like
// (Ivan, 2026-08-27).
export const KIND_COLORS = {
  mobileFill: 'rgba(94, 155, 149, 0.38)',   // sage green — mobile
  studioFill: 'rgba(110, 139, 168, 0.42)',  // slate blue — in-studio
  bothFill: 'rgba(194, 153, 47, 0.34)',
  bothBorder: 'rgba(194, 153, 47, 0.6)',
  bothInk: '#8A6D1F',
};
